import { getLocalizedPath } from './pathnames';
import { getLocalizedCategorySlug } from './categorySlugTranslations';
import { Locale, defaultLocale } from './config';

// Pure path localization - usable from server components (no usePathname).

export function localizePathFor(locale: Locale, canonicalPath: string): string {
  // First, translate category slugs if path starts with /giftcards/
  let pathToLocalize = canonicalPath;
  if (canonicalPath.startsWith('/giftcards/')) {
    const segments = canonicalPath.split('/');
    if (segments.length >= 3 && segments[2]) {
      const canonicalSlug = segments[2];
      const localizedSlug = getLocalizedCategorySlug(canonicalSlug, locale);
      segments[2] = localizedSlug;
      pathToLocalize = segments.join('/');
    }
  }

  // Then translate the base path (e.g., /giftcards -> /carduri-cadou)
  return locale === defaultLocale
    ? pathToLocalize
    : getLocalizedPath(pathToLocalize, locale);
}

export function localizeFullPathFor(locale: Locale, canonicalPath: string): string {
  const localizedPath = localizePathFor(locale, canonicalPath);
  if (locale === defaultLocale) {
    return localizedPath;
  }
  return `/${locale}${localizedPath}`;
}
